import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SearchFieldComponent } from '@modules/components/search-field/search-field.component';
import { BaseFilterItem } from '@modules/filter/directives/base-filter-item.directive';
import { provideFilterItem } from '@modules/filter/utils/token';
import { FilterBean, FilterType } from '@type/filter.type';

const DEFAULT_FILTER = new FilterBean(FilterType.String);

@Component({
  selector: 'app-f-text',
  imports: [SearchFieldComponent, FormsModule, MatCheckboxModule],
  providers: [provideFilterItem(FTextComponent)],
  templateUrl: './f-text.component.html',
  styleUrl: './f-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FTextComponent extends BaseFilterItem<FilterBean> {
  debounceModelChangeTimeMs = 500;

  translationForEmpty = 'Empty';

  debounceFilterFn = (val: null | string) => val !== null && this.filter.value !== val;

  setNewFilter(value: string | number | null | undefined) {
    typeof value !== 'undefined' && ((this.filter.value = String(value || '')), this.updateFilterChangeTime());
  }

  protected convertFilterToChips(): string[] {
    const chips: string[] = [];
    const { value, is_null } = this.filter;

    if (is_null) chips.push(this.translationForEmpty);
    value && typeof value === 'string' ?
      chips.push(`${value.length > 10 ? value.substring(0, 10) + '...' : value}`)
    : '';

    return chips;
  }

  protected resetFilterItem(item: BaseFilterItem<FilterBean>): void {
    this.filter = this.getDefaultFilter();
    this.cdr.markForCheck();
  }

  protected getDefaultFilter(): FilterBean {
    return { ...DEFAULT_FILTER, name: this.filter?.name || '', model: this.filter?.model || '' };
  }

  protected processFilterForView(filter: FilterBean) {
    this.filter.name = this.row().name;
    this.filter.model = this.row().model;
  }

  protected updateFilter() {}

  protected getNecessaryProperties(filter: FilterBean) {
    return { is_null: filter.is_null, value: filter.value };
  }
}
